import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PageHero } from '../../components/PageHero';
import ApiReferenceContent from '../../components/ApiReferenceContent';
import SEO from '../../components/SEO';

export default function ApiReference() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace('#', '');
    // Wait a tick for the content to render before scrolling to it.
    const t = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <div>
      <SEO
        title="Plagiarism & AI Detection REST API Documentation"
        description="Developer REST API for automated plagiarism checking, AI text screening, and webhook callbacks. Integrate manuscript integrity directly into your publishing workflow."
        canonicalPath="/api-reference"
        keywords="plagiarism detection api, ai content detection api, academic plagiarism api python, manuscript screening rest api, webhook plagiarism checker api"
      />
      <PageHero
        eyebrow="Developers"
        title="API reference"
        subtitle="Integrate plagiarism detection and AI content analysis directly into your publishing, editorial, or LMS workflow."
        ctas={[{ label: 'Get API access', to: '/pricing', state: { tab: 'enterprise', lockTab: true }, primary: true }]}
      />
      <section className="bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <ApiReferenceContent />
        </div>
      </section>
    </div>
  );
}
